import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AuthApi } from '../../../api/AuthApi';
const initialState = {
  status: false,
  message: '',
  data: {},
  currentRequestId: undefined,
  loading: 'idle',
  action: '',
  error: null
};

export const logout = createAsyncThunk(
  'auth/logout',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().logout;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.logout();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const logoutAllSessions = createAsyncThunk(
  'auth/logoutAllSessions',
  async (authData, { rejectWithValue, getState, requestId }) => {
    try {
      const test = await getState();
      const { currentRequestId, loading } = await getState().logout;
      if (loading !== 'pending' || requestId !== currentRequestId) return;
      const data = await AuthApi.logoutAllSessions();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const logoutSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    reset: () => initialState
  },
  extraReducers: (builder) => {
    builder
      .addCase(logout.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'logout';
          state.error = null;
        }
      })
      .addCase(logout.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(logout.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      })
      .addCase(logoutAllSessions.pending, (state, action) => {
        if (state.loading === 'idle') {
          state.loading = 'pending';
          state.currentRequestId = action.meta.requestId;
          state.action = 'logout_all';
          state.error = null;
        }
      })
      .addCase(logoutAllSessions.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.data = action.payload;
          state.status = action.payload.status;
          state.currentRequestId = undefined;
        }
      })
      .addCase(logoutAllSessions.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading === 'pending' && state.currentRequestId === requestId) {
          state.loading = 'idle';
          state.error = action.payload?.message || action.error?.message || "Network error. Please try again.";
          state.status = false;
          state.currentRequestId = undefined;
        }
      });
  }
});

export default logoutSlice.reducer;
